import React, { FunctionComponent, useEffect, useState } from "react";
import styles from "./EasyTableBooking.module.scss";
import ScriptBlockProps from "./EasyTableBooking.interface";
import BackgroundMedia from "components/BackgroundMedia/BackgroundMedia";
import combineClasses from "helpers/combine-classes";
import getWrapperClasses from "blocks/helpers/getWrapperClasses";
import setInViewClasses from "blocks/hooks/setInViewClasses";
import useSplitBackground from "blocks/hooks/useSplitBackground";
import useWrapperStyles from "blocks/hooks/useWrapperStyles";

const EasyTableBooking: FunctionComponent<ScriptBlockProps> = (props): JSX.Element => {
    const wrapperClasses = getWrapperClasses(props.settings);
    const wrapperStyles = useWrapperStyles(props.settings);
    const { inViewElementRef, inViewClasses } = setInViewClasses(styles);

    const { splitClasses, splitStyles } = useSplitBackground(props);

    const loadScript = (src: string, onLoad: () => void, onError: () => void) => {
        const scriptElement = document.createElement("script");
        scriptElement.src = src;
        scriptElement.async = true;

        scriptElement.onload = () => {
            // console.log("Easy booking Script loaded successfully");

            if (onLoad) onLoad();
        };

        scriptElement.onerror = () => {
            // console.error("Easy booking Script failed to load");
            if (onError) onError();
        };

        document.head.appendChild(scriptElement);
    };

    useEffect(() => {
        loadScript(
            "//book.easytablebooking.com/book/widget/v3/book.js",
            () => {
                // console.log("Script loaded");
                window.runEtb();
            },
            () => {
                console.error("Failed to load script");
            }
        );
        return () => {
            const scriptElement = document.querySelector('script[src="//book.easytablebooking.com/book/widget/v3/book.js"]');
            if (scriptElement) {
                scriptElement.parentNode?.removeChild(scriptElement);
            }
        };
    }, []);

    return (
        <section
            className={combineClasses(styles.wrapper, inViewClasses, ...wrapperClasses)}
            style={{ ...wrapperStyles, ...splitStyles }}
            ref={inViewElementRef}
        >
            <div className={combineClasses(styles.container, ...splitClasses)}>
                <div className={styles.content}>
                    <div
                        className={combineClasses("BookingBox", styles.booking_box_container)}
                        data-place={props.content?.easyTableDataPlaceId}
                        data-lang={props.content?.dataLanguage ?? "auto"}
                    >
                        <span>
                            I samarbejde med
                            <a
                                href="http://easytablebooking.dk/"
                                target="_blank"
                                title="Online restaurant booking"
                            >
                                easyTableBooking.dk
                            </a>
                        </span>
                    </div>
                </div>
            </div>

            {props.settings.backgroundMedia?.[0] && props.settings.backgroundMedia.length > 0 ? (
                <BackgroundMedia
                    key={props.contentUdi}
                    {...props.settings.backgroundMedia[0]}
                />
            ) : null}
        </section>
    );
};

export default EasyTableBooking;
